import { HttpService } from '@/services/Http.service'
import { HttpErrorService } from '@/services/HttpError.service'
import type { PageKit, WidgetConfiguration } from '@/models'
import { serviceErrorHandbook } from '@/models'

export class WidgetConfigurationService {
  private configEndpoint = '/widget-configurations'
  private kitEndpoint = '/widget-page-kit'
  private httpService: HttpService
  private httpErrorService: HttpErrorService<keyof typeof serviceErrorHandbook>

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      serviceErrorHandbook,
      'widgetConfiguration',
    )
  }

  async getByParams(apiKey: string, domain?: string) {
    const url = [this.configEndpoint, apiKey].join('/')
    const fetchConfig = { params: { domain } }

    return await this.httpService
      .get<WidgetConfiguration>(url, { fetchConfig })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async getWidgetPageKit(params: any) {
    const { type, key, domain, id } = params

    return await this.httpService
      .get<PageKit>(this.kitEndpoint, {
        requestConfig: {
          forceRequest: true,
          needGlobal404: true,
        },
        fetchConfig: {
          params: {
            type,
            key,
            domain,
            id,
          },
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, this.kitEndpoint)
      })
  }
}
